import { type MyLensesLensCta, MyLensesLensCtaText, MyLensesLensCtaType } from "../../gql-generated/types";
import { type DeeplinkSchema, type EditLensCtaFormValues, type WebsiteSchema } from "../validation";

export const LensCtaTypeLabelMap: Record<MyLensesLensCtaType, string> = {
    [MyLensesLensCtaType.CtaTypeUnset]: "None",
    [MyLensesLensCtaType.CtaTypeWebsite]: "Website",
    [MyLensesLensCtaType.CtaTypeDeeplink]: "Deep Link",
};

export const LensCtaTextLabelMap: Record<MyLensesLensCtaText, string> = {
    [MyLensesLensCtaText.CtaTextUnset]: "",
    [MyLensesLensCtaText.CtaTextApplyNow]: "Apply Now",
    [MyLensesLensCtaText.CtaTextBookNow]: "Book Now",
    [MyLensesLensCtaText.CtaTextBuyTickets]: "Buy Tickets",
    [MyLensesLensCtaText.CtaTextDonate]: "Donate",
    [MyLensesLensCtaText.CtaTextDownload]: "Download",
    [MyLensesLensCtaText.CtaTextGetNow]: "Get Now",
    [MyLensesLensCtaText.CtaTextInstallNow]: "Install Now",
    [MyLensesLensCtaText.CtaTextListen]: "Listen",
    [MyLensesLensCtaText.CtaTextMore]: "More",
    [MyLensesLensCtaText.CtaTextOpenApp]: "Open App",
    [MyLensesLensCtaText.CtaTextOrderNow]: "Order Now",
    [MyLensesLensCtaText.CtaTextPlay]: "Play",
    [MyLensesLensCtaText.CtaTextPlayGame]: "Play Game",
    [MyLensesLensCtaText.CtaTextPreRegister]: "Pre-Register",
    [MyLensesLensCtaText.CtaTextRead]: "Read",
    [MyLensesLensCtaText.CtaTextShow]: "Show",
    [MyLensesLensCtaText.CtaTextShowtimes]: "Showtimes",
    [MyLensesLensCtaText.CtaTextSignUp]: "Sign Up",
    [MyLensesLensCtaText.CtaTextTry]: "Try",
    [MyLensesLensCtaText.CtaTextView]: "View",
    [MyLensesLensCtaText.CtaTextViewProfile]: "View Profile",
    [MyLensesLensCtaText.CtaTextViewMenu]: "View Menu",
    [MyLensesLensCtaText.CtaTextVote]: "Vote",
    [MyLensesLensCtaText.CtaTextWatch]: "Watch",
};

// Lens Cta from - UI defaults
// use for per field yup schema validation
export const deeplinkDefault: DeeplinkSchema = {
    androidAppUrl: "",
    appName: "",
    uri: "",
};

export const websiteDefault: WebsiteSchema = {
    url: "",
};

// To avoid display empty string in the dropdown options for CTA_TEXT_UNSET
// default to More text on UI
export const lensCtaDefault: EditLensCtaFormValues = {
    type: MyLensesLensCtaType.CtaTypeUnset,
    text: MyLensesLensCtaText.CtaTextMore,
    deeplink: deeplinkDefault,
    website: websiteDefault,
};

export const makeLensCtaToSubmit = ({ text, type, website, deeplink }: EditLensCtaFormValues): MyLensesLensCta => {
    switch (type) {
        case MyLensesLensCtaType.CtaTypeWebsite:
            return {
                type: MyLensesLensCtaType.CtaTypeWebsite,
                text,
                website: { url: website.url ?? "" },
            };

        case MyLensesLensCtaType.CtaTypeDeeplink:
            return {
                type: MyLensesLensCtaType.CtaTypeDeeplink,
                text,
                deeplink: {
                    androidAppUrl: deeplink.androidAppUrl ?? "",
                    appName: deeplink.appName ?? "",
                    iosAppId: deeplink.iosAppId ?? 0,
                    uri: deeplink.uri ?? "",
                },
            };

        default:
            return { text: MyLensesLensCtaText.CtaTextUnset, type: MyLensesLensCtaType.CtaTypeUnset };
    }
};

export const makeLensCtaForUI = ({ text, type, website, deeplink }: MyLensesLensCta): EditLensCtaFormValues => {
    switch (type) {
        case MyLensesLensCtaType.CtaTypeWebsite:
            return {
                type: MyLensesLensCtaType.CtaTypeWebsite,
                text,
                website: {
                    url: website?.url,
                },
                deeplink: deeplinkDefault,
            };
        case MyLensesLensCtaType.CtaTypeDeeplink:
            return {
                type: MyLensesLensCtaType.CtaTypeDeeplink,
                text,
                deeplink: {
                    androidAppUrl: deeplink?.androidAppUrl,
                    appName: deeplink?.appName,
                    iosAppId: deeplink?.iosAppId,
                    uri: deeplink?.uri,
                },
                website: websiteDefault,
            };
        default:
            return lensCtaDefault;
    }
};
